import Chip, { type ChipProps } from "@mui/material/Chip";

type Status = "ongoing" | "inactive" | "notStarted";

type StatusChipConfig = Record<
  Status,
  {
    color: ChipProps["color"];
    label: string;
  }
>;

export const StatusChip = ({ status = "ongoing", ...props }: { status: Status }) => {
  const statusChipConfig: StatusChipConfig = {
    ongoing: {
      color: "primary",
      label: "Ongoing",
    },
    inactive: {
      color: "error",
      label: "Inactive",
    },
    notStarted: {
      color: "default",
      label: "Not Started",
    },
  };

  return (
    <Chip
      variant="status"
      color={statusChipConfig[status].color}
      label={statusChipConfig[status].label}
      {...props}
      sx={{ maxWidth: "80px" }}
    />
  );
};
